import { fetchGet } from 'Services/fetchService.js';
import { nodePath } from 'Config/path.js';
import { IService } from 'CommonTypes/Tasks/Services/IService';

export default async (serviceId: number) => {
    const result: IService[] = await fetchGet(`${nodePath}/tasks/service/?serviceId=${serviceId}`);

    return result;
};
